export enum EPermissions {
  Owner = 'owner', // deprecated
  Admin = 'admin',
  Analytics = 'analytics',
  Moderation = 'moderation',
  Producer = 'producer',
  ModeratorRegistrant = 'moderator_registrant', // deprecated
  PasscodeManager = 'passcode_manager', // deprecated
  Editor = 'editor',
  GroupAdmin = 'group_admin',
  Viewer = 'viewer', // not visible in BLP
  Builder = 'builder',
  Presenter = 'presenter', // not visible in BLP
}

export const EPermissionsDisplayNames: { [key in EPermissions]: string } = {
  [EPermissions.Owner]: 'Owner', // deprecated
  [EPermissions.Admin]: 'Admin',
  [EPermissions.Analytics]: 'Analyst',
  [EPermissions.Moderation]: 'Moderator',
  [EPermissions.Producer]: 'Producer',
  [EPermissions.ModeratorRegistrant]: 'Moderator Registrant', // deprecated
  [EPermissions.PasscodeManager]: 'Passcode Manager', // deprecated
  [EPermissions.Editor]: 'Editor',
  [EPermissions.GroupAdmin]: 'Group Manager',
  [EPermissions.Viewer]: 'Viewer', // not visible in BLP
  [EPermissions.Builder]: 'Developer',
  [EPermissions.Presenter]: 'Presenter', // not visible in BLP
};

export const PERMISSIONS: { [key: string]: EPermissions } = {
  Owner: EPermissions.Owner, // deprecated
  Admin: EPermissions.Admin,
  Builder: EPermissions.Builder,
  Editor: EPermissions.Editor,
  GroupAdmin: EPermissions.GroupAdmin,
  Analytics: EPermissions.Analytics,
  Moderation: EPermissions.Moderation,
  Producer: EPermissions.Producer,
  PasscodeManager: EPermissions.PasscodeManager, // deprecated
  ModeratorRegistrant: EPermissions.ModeratorRegistrant, // deprecated
  Viewer: EPermissions.Viewer, // not visible in BLP
  Presenter: EPermissions.Presenter, // not visible in BLP
};

export const VISIBLE_PERMISSIONS: { [key: string]: EPermissions } = {
  Admin: EPermissions.Admin,
  Builder: EPermissions.Builder,
  Editor: EPermissions.Editor,
  GroupAdmin: EPermissions.GroupAdmin,
  Analytics: EPermissions.Analytics,
  Moderation: EPermissions.Moderation,
  Producer: EPermissions.Producer,
};

// Admin, Owner, and builder are added to these in the useHasPermission hook
export const GENERAL_EDITABLE_PERMISSIONS = [EPermissions.GroupAdmin, EPermissions.Editor];
